import type { AnalyticsShoppingFinishedCallbackProps } from '../Analytics/AnalyticsSkuViewed';
import type { MonetizableEnum } from '../enums';

export function getFinishType(monetizable: MonetizableEnum) {
  if (monetizable === 'no' || monetizable === 'no_because_of_lead_form') {
    return 'internal_content';
  }
  return 'external_application';
}

interface CreateHandleOnClickProps {
  fireShoppingFinishedEvent?: (props: AnalyticsShoppingFinishedCallbackProps) => void;
  destinationUrl: string;
  monetizable: MonetizableEnum;
  overrideShoppingFinishedId?: string;
  type?: string;
}

export const createHandleOnClick =
  ({
    fireShoppingFinishedEvent,
    destinationUrl,
    monetizable,
    overrideShoppingFinishedId,
    type = 'PRODUCT_CARD_BUTTON',
  }: CreateHandleOnClickProps) =>
  () => {
    if (fireShoppingFinishedEvent) {
      return fireShoppingFinishedEvent({
        destinationUrl,
        ctaType: type,
        finishType: getFinishType(monetizable),
        interstitialClientBotSuspected: false,
        monetizable,
        overrideShoppingFinishedId,
      });
    }
  };
